/**
 * Sponsor tier badge colours — single source of truth.
 *
 * These were previously duplicated across SponsorsPage / QRWalletPage /
 * SponsorAttributionPage using pre-rebrand Tailwind hexes (platinum was
 * #e2e8f0 — light grey, invisible on white cards). These tones sit on the
 * Marakin cream/white surfaces and meet contrast on both.
 *
 * Usage: badge text = TIER_COLORS[tier], badge bg = `${TIER_COLORS[tier]}1F`.
 */
export const TIER_COLORS = {
  platinum: '#55606B', // graphite — readable "platinum" on cream
  gold: '#8A6220',     // deep gold (matches .badge-gold text in index.css)
  silver: '#6E7276',   // mid grey
  standard: '#6B6E66', // warm grey-green
};

export const tierBadgeStyle = (tier) => {
  const color = TIER_COLORS[tier] || TIER_COLORS.standard;
  return { background: `${color}1F`, color };
};
